import {
    VOUCHER_INVOICE_TYPE_VALUE,
} from "app/common/LocalConst";

import { SearchObject } from "app/common/Model/SearchObject";
import { pageOrder } from "app/services/InvoiceItemService";

import { pageVoucherTotalCategory } from "app/services/VoucherService";
import { makeAutoObservable } from "mobx";
import { toast } from "react-toastify";

const DEFAULT_SEARCH_VOUCHER_FEE = {
    ...new SearchObject(),
    patientId: null,
    // fromDate: new Date(new Date().getFullYear(), 0, 1),
    // toDate: new Date(),
    voucherInvoiceType: VOUCHER_INVOICE_TYPE_VALUE.Advance,
};
const DEFAULT_SEARCH_ORDER = {
    ...new SearchObject(),
    patientId: null,
    // fromDate: new Date(new Date().getFullYear(), 0, 1),
    // toDate: new Date(),
};

export default class VoucherOrderDepositDeductionStore {
    searchVoucherFee = {
        ...DEFAULT_SEARCH_VOUCHER_FEE,
    };
    searchOrder = {
        ...DEFAULT_SEARCH_ORDER,
    };
    dataVoucherFee = [];
    openVoucherDepositDeductionPopup = false;
    dataOrder = [];
    constructor() {
        makeAutoObservable(this);
    }

    getDataVoucherTotalCategory = async () => {
        let { ...ortherData } = this.searchVoucherFee;
        return await pageVoucherTotalCategory({ ...ortherData })
            .then(({ data }) => {
                this.dataVoucherFee = data;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lấy dữ liệu hóa đơn có lỗi");
            });
    };

    getDataOrder = async () => {
        let { ...ortherData } = this.searchOrder;

        return await pageOrder({ ...ortherData })
            .then(({ data }) => {
                this.dataOrder = data;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lấy dữ liệu hóa đơn có lỗi");
            });
    };


    handleChangeFormSearch = (search) => {
        this.searchVoucherFee = { ...this.searchVoucherFee, ...search };
        this.getDataVoucherTotalCategory();
    };

    handleChangeFormSearchOrder = (search) => {
        this.searchOrder = { ...this.searchOrder, ...search };
        this.getDataOrder();
    };

    openDepositDeductionPopup = () => {
        this.openVoucherDepositDeductionPopup = true;
    };

    closeDepositDeductionPopup = () => {
        this.openVoucherDepositDeductionPopup = false;
    };

    resetStorePopup = () => {
        this.searchVoucherFee = {
            ...DEFAULT_SEARCH_VOUCHER_FEE,
        };
        this.searchOrder = {
            ...DEFAULT_SEARCH_ORDER,
        };
        this.dataOrder = [];
        this.dataVoucherFee = [];
    };

}